<template>
  <addInmuebleView v-if="formType === 'inmueble'" />
  <addComunidadesView v-else-if="formType === 'comunidad'" />
  <div v-else class="text-center p-4">{{ $t('property.detail.loading') }}</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useRoute } from 'vue-router';
import addInmuebleView from './addInmuebleView.vue';
import addComunidadesView from './addComunidadesView.vue';
import { hasAnyRole } from '@/services/userRoles';

/**
 * /Property-new/:id?/:type? decide qué formulario mostrar: la ficha de inmueble
 * (cartera del cliente vertical) o el alta de comunidad. En edición sin tipo
 * explícito, lo lee de la propia finca.
 */
const route = useRoute();
const formType = ref(null);

const resolveType = async () => {
  const requested = route.query.type || route.params.type;
  if (requested === 'inmueble' || requested === 'comunidad') { formType.value = requested; return; }
  if (route.params.id) {
    try {
      const response = await axios.get(`${import.meta.env.VITE_API_URL}/property/get/${route.params.id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      formType.value = response.data?.value?.type === 'inmueble' ? 'inmueble' : 'comunidad';
      return;
    } catch {
      // sin dato, se cae al criterio por rol
    }
  }
  // Un cliente solo vertical trabaja con inmuebles; el resto, con comunidades
  formType.value = hasAnyRole(['vertical']) && !hasAnyRole(['horizontal']) ? 'inmueble' : 'comunidad';
};

onMounted(resolveType);
</script>
